module.exports = __webpack_public_path__ + "img/img_5.72f2d1ba.jpeg";